declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SectionData, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, FormOrganizer, SaveOTSectionDataRequest, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest, FollicularScanDetailController, FollicularScanDetailRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, SaveFollicularScanDetailRequest, SaveFollicularScanOvaryDetailRequest, SaveIvfCycleTestDataRequest, SaveIvfCycleMedicineDataRequest, SaveTestMedCycleActivitiesRequest, IvfTreatmentPlanController, IvfTreatmentPlanRequest, SaveFollicularPickupsDetailV2Request, FollicularPickUpsByCodeController, FollicularPickUpsByCodeRequest, UpdateIvfCycleByActivityRequest, TreatmentCycleActiityMasterController, IvfCycleActivityMasterRequest, OocyteQualityAssessmentByCodeController, OocyteQualityAssessmentByCodeRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, OocyteMaturityByCycleController, OocyteMaturityByCycleRequest, SaveSingleWellFollicleRequest, SaveOocyteMaturityInfoRequest, SaveOocyteMorphologyInfoRequest, SaveIvfOocyteEmbryoStorageRequest, SaveCycleStatusRequest, OocyteMorphologyByCycleController, OocyteMorphologyByCycleRequest, OqaDetails, OocyteAbnormalitiesDetails, SpermSourceDetailsController, SpermSourceDetailsRequest, IvfSpermStoreByCodeController, IvfSpermStoreByCodeRequest, SaveSpermDetailsRequest, SaveSemenDataRequest, SaveIvfSpermStoreRequest, SaveSingleWellInseminationInfoRequest, SaveIvfCycleInseminationLogRequest, SaveIvfCycleInseminationInfoRequest, CompleteIvfCycleInseminationRequest, SingleWellInseminationByCycleController, SingleWellInseminationByCycleRequest, IvfCycleInseminationLogByCycleWithDOCController, IvfCycleInseminationLogByCycleWithDOCRequest, IvfCycleInseminationByCycleController, IvfCycleInseminationByCycleRequest, SingleWellCultureByCycleCodeController, SingleWellCultureByCycleCodeRequest, SaveSingleEmbryoGradeInfoRequest, SaveEmbryoStoreInfoRequest, ReadyForEmbroTransferRequest, ConvertEmbryoGradingToWellCultureRequest, EmbryosFromStoreController, EmbryosFromStoreRequest, IvfCycleEmbryoTransferrablesController, IvfCycleEmbryoTransferrablesRequest, IvfEmbryoGradingByCycleController, IvfEmbryoGradingByCycleRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe, OocyteAbPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbEditOvaryModal } from '../ivfworkbench/editovary.modal';
import { NgbAddScanTestModal } from '../ivfworkbench/addscantest.modal';
import { NgbAddScanMedicineModal } from '../ivfworkbench/addscanmedicine.modal';
import { NgbEditScanMedicineModal } from '../ivfworkbench/editscanmedicine.modal';
import { NgbEditScanTestModal } from '../ivfworkbench/editscantest.modal';
import { NgbEventAddModal } from './eventadd.modal';
import { PrintService } from '../../../../services/print.service';
import { NgbSearchProviderModal } from '../ivfworkbench/searchprovider.modal';
import { NgbAddOqaModal } from '../ivfworkbench/addoqa.modal';
import { NgbEditOqaModal } from '../ivfworkbench/editoqa.modal';
import { NgbAddAbnormalOqaModal } from '../ivfworkbench/addabnormaloqa.modal';
import { NgbEditAbnormalOqaModal } from '../ivfworkbench/editabnormaloqa.modal';
import { NgbSearchDonarModal } from './searchdonar.modal';
import { NgbAddInseminationLogModal } from '../ivfworkbench/addinseminationlog.modal';
import { NgbEditInsemiModal } from '../ivfworkbench/editinsemi.modal';
import { NgbEditInseminationLogModal } from '../ivfworkbench/editinseminationlog.modal';
import { NgbEditGradingModal } from '../ivfworkbench/editgrading.modal';
import { NgbEditGradingDayModal } from '../ivfworkbench/editgradingday.modal';
import { NgbEditGradingetModal } from '../ivfworkbench/editgradinget.modal';
import { NgbEditGradingFetDetailModal } from '../ivfworkbench/editgradingfetdetail.modal';
import { NgbEmbryoStoreLocationModal } from '../ivfworkbench/embryostorelocation.modal';

@Component({
    selector: 'freezingedit',
    templateUrl: './freezingedit.modal.html',
    styleUrls: ['./freezingedit.modal.scss']
})

export class NgbFreezingEditModal implements OnInit {
    @ViewChild('f') IdentitiesForm: NgForm;
    @Input() ActorCode:number;
    @Input() TemplateName: string;
    @Input() CycleCode: number;
    @Input() FollicularGrowthCode: number;
    @Input() ActivityCode: number;
    //@Input() PatientCode: number;
    @Input() FormattedCode: string;
    @Input() IsShowDetail: boolean = false;
    @Input() SectionSequenceNO: number;
    @Input() SectionTypeCode: number;
    @Input() Date: Date;
    @Input() Sign1: string;
    @Input() Sign2: string;
    @Input() TitleName: string;
    @Input() DOC: number;
    @Input() GradingModel: string;
    @Input() sectionData: SectionData;
    @Input() PatientReportCode: any;
    OvulationTriggerDate: NgbDateStruct;
    public ActivityDate: NgbDateStruct;
    public displayPatientdata: boolean = true;
    public displayscansdata: boolean = false;
    @Input() Eggsourcetype: string;
    public EggSourceType: string;
    ExpiryDate: NgbDateStruct;
    ExpiryDate2: NgbDateStruct;
    OvumPickupdate: NgbDateStruct;
    OvumPlannedPickupDate: NgbDateStruct;
    DateofSampleCollection: NgbDateStruct;
    public Frozen: number;
    //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
    @Input() ServiceCode: number;
    searchTitle: string;
    ScanDate: NgbDateStruct;
    NextScanDate: NgbDateStruct;
    public SelectedEmbryocount: number;
    public EggSourceActorCode: number;
    public DOCSelected: number;
    public OvulationtriggerDate: Date;
    //private isvisibleendo: boolean = true;
    public ApiResData: ApiResponseModel;
   // public data: string;
    public isRequesting: boolean = false;
    public ShowService: boolean = true;
    private isvisible: boolean = true;
    public ActivityCodeNew: number;
    private isvisibleendo: boolean = true;
    public SelectedGrades: string;
    public SelecctedGrades2: string;
    public SelectedFrozenCount: number;
    public Frozennumber: number;
    public Day: number;
    public month: number;
    public Year: number;
    public length: number;
    public Displaynew: boolean = false;
    public Displayold: boolean = true;
    //public IsSelected: boolean;
    ExtractionDate: NgbDateStruct;
    CurrentSaveSingleEmbryoGradeInfoRequest: SaveSingleEmbryoGradeInfoRequest;
    CurrentSaveIvfOocyteEmbryoStorageRequest: SaveIvfOocyteEmbryoStorageRequest;
    CurrentEditEmbryoStoreInfoRequest: SaveEmbryoStoreInfoRequest;
    CurrentReadyForEmbroTransferRequest: ReadyForEmbroTransferRequest;
    CurrentConvertEmbryoGradingToWellCultureRequest: ConvertEmbryoGradingToWellCultureRequest;
    CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
    SelectedpatientDetails: TreatmentCyclesByActorCodeController;

    CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
    LoadPatients() {
       // alert("patientsdetails");
        this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesByActorCodeController();
    }

    GetTreatmentCyclesByActorCodeController() {
        this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
                    this.SelectedpatientDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
                    //this.LMPDate = this.SelectedTreatmentCycle.LMP;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                   /// this.LoadDSAData();
                    //this.LoadPlan();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
      private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe, public printService: PrintService,
      private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private modalService: NgbModal,
      private tosterservice: NGXToastrService, private spinner: NgxSpinnerService, private parserFormatter: NgbDateParserFormatter, private filter2: OocyteAbPipe,) { }
  ngOnInit() {
   
    this.ShowService = false;
      this.CurrentSaveSingleEmbryoGradeInfoRequest = new SaveSingleEmbryoGradeInfoRequest();
      this.CurrentSaveSingleEmbryoGradeInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveIvfOocyteEmbryoStorageRequest = new SaveIvfOocyteEmbryoStorageRequest();
      this.CurrentSaveIvfOocyteEmbryoStorageRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentReadyForEmbroTransferRequest = new ReadyForEmbroTransferRequest();
      this.CurrentReadyForEmbroTransferRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentConvertEmbryoGradingToWellCultureRequest = new ConvertEmbryoGradingToWellCultureRequest();
      this.CurrentConvertEmbryoGradingToWellCultureRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentEditEmbryoStoreInfoRequest = new SaveEmbryoStoreInfoRequest();
      this.CurrentEditEmbryoStoreInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.LoadPatients();
     
      this.LoadCycles();
      this.LoadGradingData2();
     // this.LoadPatients2();
      //this.LoadGradingData3();
      this.LoadGradingData();
      
      this.LoadSingle();
      //this.LoadOqaData();
     // this.LoadFET();
      //this.LoadSingle();
      //this.LoadOqaData();
      //this.LoadFET();

      //this.LoadScansData();
      //this.LoadOvaryData();
      
      //this.LoadTestData();
      //this.LoadMedicineData();

  }


    CurrentIvfCycleEmbryoTransferrablesController: IvfCycleEmbryoTransferrablesController[];
    CurrentIvfCycleEmbryoTransferrablesRequest: IvfCycleEmbryoTransferrablesRequest;

    LoadGradingData2() {
        //alert("ScansData")
        this.CurrentIvfCycleEmbryoTransferrablesRequest = new IvfCycleEmbryoTransferrablesRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleEmbryoTransferrablesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleEmbryoTransferrablesController();
    }
    //AddRowMaturity() {
    //  if (this.CurrentOocyteMaturityByCycleController == null) {
    //    this.CurrentOocyteMaturityByCycleController = new Array<OocyteMaturityByCycleController>();
    //  }
    //  if (this.CurrentOocyteMaturityByCycleController != null) {

    //    var row = new OocyteMaturityByCycleController();

    //    row.MaturityLevel = "";
    //    row.OccCount = 0;
    //    row.DenudedCount = 0;
    //    this.CurrentOocyteMaturityByCycleController.push(row);
    //    this.tosterservice.ToasterSuccessAlertParam('New Row Added Successfully.....!');

    //  }

    //}
    //checkDoc(val: number): boolean {
    //    return val.toString() == this.DOC;
    //}
    GetIvfCycleEmbryoTransferrablesController() {
        //  alert(this.DOC);
        this.CurrentIvfCycleEmbryoTransferrablesRequest.ConditionalOperator = 10;
        this.CurrentIvfCycleEmbryoTransferrablesRequest.CycleCode = this.CycleCode;
        // this.CurrentIvfEmbryoGradingByCycleRequest.DOC = "";


        this.actorservice.GetIvfCycleEmbryoTransferrablesController(this.CurrentIvfCycleEmbryoTransferrablesRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    this.CurrentIvfCycleEmbryoTransferrablesController = this.ApiResData.Result;
                    this.length = this.CurrentIvfCycleEmbryoTransferrablesController.length;
                    this.LoadPatients2();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentTreatmentCyclesByActorCodeController2: TreatmentCyclesByActorCodeController[];
    ActorDetails: TreatmentCyclesByActorCodeController;
    CurrentTreatmentCyclesByActorCodeRequest2: TreatmentCyclesByActorCodeRequest;
    LoadPatients2() {
        this.CurrentTreatmentCyclesByActorCodeRequest2 = new TreatmentCyclesByActorCodeRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesByActorCodeRequest2.Branch = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest2.ActorCode = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest2.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesByActorCodeRequest2.FromDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest2.ToDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest2.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesByActorCodeRequest2.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesByActorCodeController2();
    }

    GetTreatmentCyclesByActorCodeController2() {
        // this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest2)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesByActorCodeController2 = this.ApiResData.Result;
                    this.ActorDetails = this.CurrentTreatmentCyclesByActorCodeController2[0];
                    this.LoadGradingData3();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentIvfCycleEmbryoTransferrablesControllerByActor: IvfCycleEmbryoTransferrablesController[];
    CurrentIvfCycleEmbryoTransferrablesRequestByActor: IvfCycleEmbryoTransferrablesRequest;

    LoadGradingData3() {
        //alert("ScansData")
        this.CurrentIvfCycleEmbryoTransferrablesRequestByActor = new IvfCycleEmbryoTransferrablesRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleEmbryoTransferrablesRequestByActor.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleEmbryoTransferrablesController2();
    }
    //AddRowMaturity() {
    //  if (this.CurrentOocyteMaturityByCycleController == null) {
    //    this.CurrentOocyteMaturityByCycleController = new Array<OocyteMaturityByCycleController>();
    //  }
    //  if (this.CurrentOocyteMaturityByCycleController != null) {

    //    var row = new OocyteMaturityByCycleController();

    //    row.MaturityLevel = "";
    //    row.OccCount = 0;
    //    row.DenudedCount = 0;
    //    this.CurrentOocyteMaturityByCycleController.push(row);
    //    this.tosterservice.ToasterSuccessAlertParam('New Row Added Successfully.....!');

    //  }

    //}
    //checkDoc(val: number): boolean {
    //    return val.toString() == this.DOC;
    //}
    GetIvfCycleEmbryoTransferrablesController2() {
        //  alert(this.DOC);
        this.CurrentIvfCycleEmbryoTransferrablesRequestByActor.ConditionalOperator = 20;
        if (this.ActorDetails.EggSourceType == 'Donor') {
            this.CurrentIvfCycleEmbryoTransferrablesRequestByActor.ActorCode = this.ActorDetails.EggActorCode;
        }
        else if (this.ActorDetails.EggSourceType == 'Self') {
            this.CurrentIvfCycleEmbryoTransferrablesRequestByActor.ActorCode = this.ActorDetails.EggActorCode;
        }

        // this.CurrentIvfEmbryoGradingByCycleRequest.DOC = "";


        this.actorservice.GetIvfCycleEmbryoTransferrablesController(this.CurrentIvfCycleEmbryoTransferrablesRequestByActor)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    this.CurrentIvfCycleEmbryoTransferrablesControllerByActor = this.ApiResData.Result;
                    //   var _CurrentIvfEmbryoGradingByCycleController: IvfEmbryoGradingByCycleController[]  = this.ApiResData.Result;
                    //   alert('grades count: ' + _CurrentIvfEmbryoGradingByCycleController.length.toString());
                    //this.CurrentIvfEmbryoGradingByCycleController = _CurrentIvfEmbryoGradingByCycleController.filter(
                    //    function (v, i, d) {
                    //    //if (v.DOC.toString() == this.DOC)
                    //    //    alert('Mmmmmm');
                    //        return this.checkDoc(v.DOC);//.toString() == this.DOC
                    //});
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentIvfEmbryoGradingByCycleController: IvfEmbryoGradingByCycleController[];
    CurrentIvfEmbryoGradingByCycleRequest: IvfEmbryoGradingByCycleRequest;

    LoadGradingData() {
        //alert("ScansData")
        this.CurrentIvfEmbryoGradingByCycleRequest = new IvfEmbryoGradingByCycleRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfEmbryoGradingByCycleRequest.CycleCode = this.CycleCode;
        //this.CurrentIvfEmbryoGradingByCycleRequest.DOC = '2';
        this.CurrentIvfEmbryoGradingByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfEmbryoGradingByCycleController();
    }
    //AddRowMaturity() {
    //  if (this.CurrentOocyteMaturityByCycleController == null) {
    //    this.CurrentOocyteMaturityByCycleController = new Array<OocyteMaturityByCycleController>();
    //  }
    //  if (this.CurrentOocyteMaturityByCycleController != null) {

    //    var row = new OocyteMaturityByCycleController();

    //    row.MaturityLevel = "";
    //    row.OccCount = 0;
    //    row.DenudedCount = 0;
    //    this.CurrentOocyteMaturityByCycleController.push(row);
    //    this.tosterservice.ToasterSuccessAlertParam('New Row Added Successfully.....!');

    //  }

    //}
    //checkDoc(val: number): boolean {
    //    return val.toString() == this.DOC;
    //}
    GetIvfEmbryoGradingByCycleController() {
        //  alert(this.DOC);
        this.spinner.show();
        this.CurrentIvfEmbryoGradingByCycleRequest.ConditionalOperator = 10;



        this.actorservice.GetIvfEmbryoGradingByCycleController(this.CurrentIvfEmbryoGradingByCycleRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    this.CurrentIvfEmbryoGradingByCycleController = this.ApiResData.Result;
                    this.spinner.hide();
                    this.Frozen = this.CurrentIvfEmbryoGradingByCycleController.filter((item) => item.SelectedFreezeCount)
                        .map((item) => +item.SelectedFreezeCount)
                        .reduce((sum, current) => sum + current)


                    // this.Frozennumber = this.CurrentIvfEmbryoGradingByCycleController[0].SelectedFreezeCount;
                    //alert(this.Frozennumber);
                    //   var _CurrentIvfEmbryoGradingByCycleController: IvfEmbryoGradingByCycleController[]  = this.ApiResData.Result;
                    //   alert('grades count: ' + _CurrentIvfEmbryoGradingByCycleController.length.toString());
                    //this.CurrentIvfEmbryoGradingByCycleController = _CurrentIvfEmbryoGradingByCycleController.filter(
                    //    function (v, i, d) {
                    //    //if (v.DOC.toString() == this.DOC)
                    //    //    alert('Mmmmmm');
                    //        return this.checkDoc(v.DOC);//.toString() == this.DOC
                    //});
                }
                else {
                    this.stopRefreshing();
                    this.spinner.hide();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                        this.spinner.hide();


                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                }


            );
    }
    onKey(number: number) { // without type info
        //alert(number);
        this.Frozen = number;
    }
    CurrentSingleWellCultureByCycleCodeController: SingleWellCultureByCycleCodeController[];
    CurrentSingleWellCultureByCycleCodeRequest: SingleWellCultureByCycleCodeRequest;
    LoadSingle() {

        this.CurrentSingleWellCultureByCycleCodeRequest = new SingleWellCultureByCycleCodeRequest();
        this.CurrentSingleWellCultureByCycleCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentSingleWellCultureByCycleCodeRequest.ConditionalOperator = 10;
        this.CurrentSingleWellCultureByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetSingleWellCultureByCycleCodeController()
    }
    GetSingleWellCultureByCycleCodeController() {
        //this.StartRefreshing();


        this.actorservice.GetSingleWellCultureByCycleCodeController(this.CurrentSingleWellCultureByCycleCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentSingleWellCultureByCycleCodeController = this.ApiResData.Result;

                    ////var list = this.CurrentSingleWellCultureByCycleCodeController.filter(
                    ////    function (a) {
                    ////        return a.IsTransFerred == true
                    ////    });

                    ////this.CurrentSingleWellCultureByCycleCodeController = list;

                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.stopRefreshing();
                    this.LoadActorCode();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    CurrentIvfTreatmentPlanController: IvfTreatmentPlanController;
    PlanDetails: IvfTreatmentPlanController;
    CurrentIvfTreatmentPlanRequest: IvfTreatmentPlanRequest;
    LoadActorCode() {
        this.CurrentIvfTreatmentPlanRequest = new IvfTreatmentPlanRequest();
        this.CurrentIvfTreatmentPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentIvfTreatmentPlanRequest.CycleCode = this.CycleCode;
        this.CurrentIvfTreatmentPlanRequest.ConditionalOperator = 10;
        this.CurrentIvfTreatmentPlanRequest.ActorCode = 0;


        this.GetIvfTreatmentPlanController();
    }

    GetIvfTreatmentPlanController() {
        //this.StartRefreshing();
        //this.spinner.show();

        this.actorservice.GetIvfTreatmentPlanController(this.CurrentIvfTreatmentPlanRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    this.CurrentIvfTreatmentPlanController = this.ApiResData.Result;
                    this.PlanDetails = this.CurrentIvfTreatmentPlanController[0];
                    //this.CurrentCounsellingActivitiesByTimeController = this.ApiResData.Result;
                    //this.RefreshPatientsByDate();
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.spinner.hide();
                    //this.stopRefreshing();
                    //this.LoadActivities();
                   // this.LoadActorCodedetails();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
   

    CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
    SemanAnalysis: TreatmentCycleStatusController[];
    SemanAnalysis2: TreatmentCycleStatusController;
    CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
    LoadCycles() {
        this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.CycleCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

        //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
        this.GetTreatmentCycleStatusController();
    }

    GetTreatmentCycleStatusController() {
        // this.StartRefreshing();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();
        //this.spinner.show();
        this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
                    this.SemanAnalysis = this.ApiResData.Result;
                    var Semanlist = this.SemanAnalysis.filter(
                        function (a) {
                            return a.PhaseActivity == "Freezing";
                        });
                    this.SemanAnalysis = Semanlist;
                    this.SemanAnalysis2 = this.SemanAnalysis[0];
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.stopRefreshing();
                    this.LoadDSAData();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    
    CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
    DSADetails: DSAActivityByCycleCodeController;
    CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;

    LoadDSAData() {
       //alert("ScansData")
        this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetDSAActivityByCycleCodeController();
    }

    GetDSAActivityByCycleCodeController() {
        //this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
        //this.EggSourceType = this.SelectedpatientDetails.EggSourceType;
        this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.ActorCode;//this.GetActorCode(this.Eggsourcetype);
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
                    this.DSADetails = this.GetCycleActivity2(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.SelectedpatientDetails.ProtocolStartDate)[0];
                    //alert(this.DSADetails);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

                    //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
                    //var list = this.CurrentDSAActivityByCycleCodeController.filter(


                    //    function (a) {
                    //        var Date = this.FollicularScanEndInfo.ScanDate;
                    //        var ActorCode = this.SelectedpatientDetails.ActorID;
                    //        return a.ActivityDate == Date && a.ActorCode == ActorCode
                    //    });

                    //this.CurrentDSAActivityByCycleCodeController = list;
                    //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
                    //alert(this.Doc1);
                    //alert(this.Antag);
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    //    GetDsADetails(ActorCode: number, Date: Date) {


    //}
    GetCycleActivity2(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
        //alert(ReceipientActorCode);
        //alert(TransferDateNew);
        return this.CurrentDSAActivityByCycleCodeController.filter(
            function (v, i, d) {

                return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
            }
        )

    }
    GetActorCode(EggSourceType: string): number {
        // alert("new");
        if (EggSourceType == 'Donor') {
            var DonorActorCode = this.SelectedpatientDetails.EggActorCode;
            return DonorActorCode;
        }
        else if (EggSourceType == 'Self') {
            var OwnerActorCode = this.SelectedpatientDetails.EggActorCode;
            return OwnerActorCode;
        }
    }
    CurrentTreatmentCycleActiityMasterController: TreatmentCycleActiityMasterController[];
    ActivityCodeInfo: TreatmentCycleActiityMasterController;
    CurrentIvfCycleActivityMasterRequest: IvfCycleActivityMasterRequest;

    LoadMasterReq() {
        //alert("ScansData")
        this.CurrentIvfCycleActivityMasterRequest = new IvfCycleActivityMasterRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleActivityMasterRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCycleActiityMasterController();
    }

    GetTreatmentCycleActiityMasterController() {
        //this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        //this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
        //this.CycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
        this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.CycleCode;
        this.CurrentIvfCycleActivityMasterRequest.ConditionalOperator = 10;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        //this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetTreatmentCycleActiityMasterController(this.CurrentIvfCycleActivityMasterRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentTreatmentCycleActiityMasterController = this.ApiResData.Result;
                    
                    //this.LoadTestData();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.GetCycleActivity(this.ActorCode, this.ScanDate);

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    GetCycleActivity(ReceipientActorCode: number, TransferDateNew: Date): TreatmentCycleActiityMasterController[] {
        //alert(ReceipientActorCode);
        //alert(TransferDateNew);
        return this.CurrentTreatmentCycleActiityMasterController.filter(
            function (v, i, d) {

                return v.ActorID == ReceipientActorCode && v.DocDate == TransferDateNew;
            }
        )

    }
   
    
    

    

    CurrentEmbryosFromStoreController: EmbryosFromStoreController[];

    CurrentEmbryosFromStoreRequest: EmbryosFromStoreRequest;
    LoadFET() {
        this.CurrentEmbryosFromStoreRequest = new EmbryosFromStoreRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentEmbryosFromStoreRequest.ActorCode = this.SelectedpatientDetails.EggActorCode;
        this.CurrentEmbryosFromStoreRequest.DOC = "";
        this.CurrentEmbryosFromStoreRequest.ConditionalOperator = 10;

        //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

        //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentEmbryosFromStoreRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
        this.GetEmbryosFromStoreController();
    }

    GetEmbryosFromStoreController() {
        //this.StartRefreshing();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

        this.actorservice.GetEmbryosFromStoreController(this.CurrentEmbryosFromStoreRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentEmbryosFromStoreController = this.ApiResData.Result;

                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
   
    AddEmbryotostore() {
        const modalRef = this.modalService.open(NgbEmbryoStoreLocationModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false

            })
        modalRef.componentInstance.SelectedGrades = this.CurrentIvfEmbryoGradingByCycleController.filter(
            function (a) {
                return a.IsSelected == true && a.AvailableCount >= a.SelectedFreezeCount
            });; //l.IsSelected
        modalRef.componentInstance.ModalType = "NewStore";
        modalRef.componentInstance.Day = this.DOCSelected;
        modalRef.componentInstance.Embryocount = this.SelectedEmbryocount;
        modalRef.componentInstance.Grade1 = this.SelectedGrades;
        modalRef.componentInstance.Grade2 = this.SelecctedGrades2;
        modalRef.componentInstance.CycleCode = this.CycleCode;
        modalRef.componentInstance.EmbryoGradingCode = 0;
        modalRef.componentInstance.FrozenCount = this.SelectedFrozenCount;
        modalRef.componentInstance.Frozennumber = this.Frozennumber;
        modalRef.result.then(x => { this.GetIvfEmbryoGradingByCycleController() })
        //modalRef.componentInstance.SelectedData = this.SelectedData;
        // modalRef.componentInstance.Mode = "Edit";
        //modalRef.componentInstance.DOC = this.DOC;
        //modalRef.componentInstance.CurrentEditEmbryoGradingInfoRequest = this.CurrentEditEmbryoGradingInfoRequest;
        //modalRef.result.then(x => { this.GetIvfEmbryoGradingByCycleController() })
        //alert("new");

        // modalRef.componentInstance.Mode = "Edit";
        //modalRef.componentInstance.DOC = this.DOC;
        //modalRef.componentInstance.CurrentEditEmbryoGradingInfoRequest = this.CurrentEditEmbryoGradingInfoRequest;

    }
    SelectedData: IvfEmbryoGradingByCycleController;
    dataChanged2(obj, l: IvfEmbryoGradingByCycleController) {
        // alert(obj);
        if (!obj) {
            l.SelectedFreezeCount = 0;
            this.Frozen = this.CurrentIvfEmbryoGradingByCycleController.filter((item) => item.SelectedFreezeCount)
                .map((item) => +item.SelectedFreezeCount)
                .reduce((sum, current) => sum + current)
        }
    }
   
    BackToPatientdata() {
        this.displayPatientdata = true;
        this.displayscansdata = false;
    }
    BackTodashboard2() {
        //this.Showivf = true;
        //this.Showscan = false;
        this.router.navigate(['healins/ivfworkbench']);
    }

    //printgrading() {
    //    this.printService.printDocument("embryograding",
    //        {
    //            Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
    //            TreatmentCycleCodedata: this.CycleCode, ActorCodedata: this.ActorCodeDetails.EggActorCode, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate /*TotalOocytes: this.SelectedpatientDetails.TotalOocytes*/
    //        }
    //    );
    //}
    //printgradingdroplet() {
    //    this.printService.printDocument("embryogradingdroplet",
    //        {
    //            Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
    //            TreatmentCycleCodedata: this.CycleCode, ActorCodedata: this.ActorCodeDetails.EggActorCode, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate /*TotalOocytes: this.SelectedpatientDetails.TotalOocytes*/
    //        }
    //    );
    //}
    //printfet() {
    //    this.printService.printDocument("fet",
    //        {
    //            Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
    //            TreatmentCycleCodedata: this.CycleCode, ActorCodedata: this.ActorCodeDetails.EggActorCode, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate /*TotalOocytes: this.SelectedpatientDetails.TotalOocytes*/
    //        }
    //    );
    //}
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }

  



}


export class EmbryoStoreItem {

    public OocyteEmbryoStorageCode: number;

    public WellNo: number;
    public StorageUnitType: string;
    public StorageUnitDetails: string;
    public Status: string;

    public Grade: string;
    //public Morphology: string;
    public IsSelected: boolean;
}
